import { Component } from '@angular/core';

@Component({
    selector: 'app-notfound',
    templateUrl: './app.notfound.component.html',
    standalone: false
})
export class AppNotfoundComponent {

}
